import { render, staticRenderFns } from "./Sales.vue?vue&type=template&id=2ba0512a"
import script from "./Sales.vue?vue&type=script&lang=js"
export * from "./Sales.vue?vue&type=script&lang=js"
import style0 from "./Sales.vue?vue&type=style&index=0&id=2ba0512a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports